import { render, staticRenderFns } from "./radio-widget.vue?vue&type=template&id=1c0e7671&scoped=true"
import script from "./radio-widget.vue?vue&type=script&lang=js"
export * from "./radio-widget.vue?vue&type=script&lang=js"
import style0 from "./radio-widget.vue?vue&type=style&index=0&id=1c0e7671&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e7671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0e7671')) {
      api.createRecord('1c0e7671', component.options)
    } else {
      api.reload('1c0e7671', component.options)
    }
    module.hot.accept("./radio-widget.vue?vue&type=template&id=1c0e7671&scoped=true", function () {
      api.rerender('1c0e7671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/radio-widget.vue"
export default component.exports